import { ToolbarState } from "./types";

const state: ToolbarState = {
  showAnswers: true,
  dictionary: {
    isEnabled: false,
    word: "",
    tooltip: {
      left: 0,
      top: 0,
      isShown: false,
    },
  },
  wholeSectionComments: [],
  wholeSectionCommentsLoading: false,
  filter: {},
  showCommentsForPrint: false,
  speechEnabled: false,
  scenarioDescription: null,
  printEnabled: true,
  calculator: null,
};

export default state;
